// Reports — how the club is running: who belongs, who turns up, what the
// courts are doing. Money moved to Financials when the admin tiles were
// consolidated; the panels themselves live in ClubReports, which both pages
// draw from.
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import ClubReports from './ClubReports';

export default function Reports() {
  return (
    <ClubReports
      title="Reports"
      subtitle="Membership, attendance and court usage."
      showStatCards
      panels={['membership', 'attendance', 'courtUsage']}
      note={(
        <>
          Purchases, staff pay and expenses moved to{' '}
          <MuiLink component={RouterLink} to="/admin/financials" underline="hover">Financials</MuiLink>.
          Error, event and Stripe logs are on{' '}
          <MuiLink component={RouterLink} to="/admin/logs" underline="hover">Logs</MuiLink>.
        </>
      )}
    />
  );
}
